import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from './store';
import { createSelector } from '@reduxjs/toolkit';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const selectAuthForNavigation = createSelector(
    (state: RootState) => state.auth,
    (state: RootState) => state.helpLink,
    (state: RootState) => state.themeEditor,
    (auth, helpLink, themeEditor) => ({
        auth,
        helpLink,
        themeEditor,
    }),
);
